import React from "react";
import {
  Box,
  Button,
  makeStyles,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(0),
  },
  toolbarLeftButton: {
    marginRight: theme.spacing(1),
  },
}));

const Toolbar = ({
  className,
  dialogHandler,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" justifyContent="flex-end">
      <Box
        display="flex"
        justifyContent="flex-end"
      >
         <Button
          color="primary"
          variant="contained"
          component={RouterLink}
          className={classes.toolbarLeftButton}
          to={`/kalendarz/nowewydarzenie`}
        >
          Dodaj wydarzenie
        </Button>
       
      </Box>
      <Button color="secondary" variant="contained" onClick={dialogHandler}>
        Usuń zaznaczone
      </Button>
    </Box>
  );
};

export default Toolbar;
